import comp from "./BulkDuplicateTemplateModal";
export default comp;
